/**
 * 목적격 조사 «을/를» 을 앞 말의 받침에 맞춰 붙인다.
 * 화면에 «인증서을(를) 채우면» 처럼 조사가 어긋나 보이던 것(V-15).
 * 한글로 끝나지 않으면(영문·숫자) 받침을 알 수 없어 «을(를)» 로 둔다.
 */
export function withObjectParticle(word: string): string {
  const trimmed = word.trimEnd();
  const last = trimmed.charCodeAt(trimmed.length - 1);
  if (Number.isNaN(last) || last < 0xac00 || last > 0xd7a3) {
    return `${trimmed}을(를)`;
  }
  const hasFinalConsonant = (last - 0xac00) % 28 !== 0;
  return `${trimmed}${hasFinalConsonant ? "을" : "를"}`;
}
